import { Link } from "react-router-dom";
import PageHeader from "@/components/marketing/PageHeader";
import { IMG } from "@/data/content";
import safetyContent from "@/data/safetyUpdates.json";
const { certifications, awards, certificationsIntro, specializedExpertise, awardsIntro, awardOrganizations, awardsMeaning } = safetyContent;

export default function SafetyRecognitionPage({ type }) {
  const isAwards = type === "awards";
  const title = isAwards ? "Safety Awards" : "Safety Certifications";
  return <div data-testid={`safety-${type}-page`}>
    <PageHeader overline="Safety" crumb={title} title={title} image={IMG.safetyBanner} />
    <section className="bg-rc-bg py-16 lg:py-24">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <nav aria-label="Safety pages" className="flex flex-wrap gap-3 mb-12">
          <Link to="/safety" className="rounded-full border border-rc-red px-5 py-3 font-semibold text-rc-red">Safety Culture</Link>
          <Link to={isAwards ? "/safety/certifications" : "/safety/awards"} className="rounded-full bg-rc-red px-5 py-3 font-semibold text-white">{isAwards ? "Safety Certifications" : "Safety Awards"}</Link>
        </nav>
        <p className="text-rc-brown text-lg leading-relaxed mb-12">{isAwards ? awardsIntro : certificationsIntro}</p>
        {isAwards ? <div className="space-y-16">{awards.map(({ year, groups }) => <section key={year} aria-labelledby={`awards-${year}`}>
          <h2 id={`awards-${year}`} className="font-heading text-5xl font-black text-rc-red mb-8">{year}</h2>
          <div className="space-y-6">{groups.map(({ organization, teams }) => <article key={organization} className="rounded-2xl border border-black/10 bg-white p-6 sm:p-8">
            <h3 className="font-heading text-2xl font-bold text-rc-blue">{organization}</h3>
            <p className="mt-4 text-rc-brown leading-relaxed">{awardOrganizations[organization]}</p>
            <div className={`mt-6 grid gap-8 ${teams.length > 1 ? "md:grid-cols-2" : ""}`}>{teams.map(({ name, awards: items }, index) => <div key={name || index}>
              {name && <h4 className="font-heading text-xl font-bold text-rc-charcoal mb-3">{name}</h4>}
              <ul className="list-disc pl-5 space-y-3 text-rc-brown leading-relaxed">{items.map(item => <li key={item}>{item}</li>)}</ul>
            </div>)}</div>
          </article>)}</div>
        </section>)}</div> : <div className="grid md:grid-cols-2 gap-6">{certifications.map(({ title: heading, body, items }) => <article key={heading} className="rounded-2xl border border-black/10 bg-white p-6 sm:p-8">
          <h2 className="font-heading text-2xl font-bold text-rc-blue">{heading}</h2>
          {body && <p className="mt-4 leading-relaxed text-rc-brown">{body}</p>}
          {items.length > 0 && <ul className="mt-4 list-disc pl-5 space-y-3 leading-relaxed text-rc-brown">{items.map(item => <li key={item}>{item}</li>)}</ul>}
        </article>)}</div>}
        <section className="mt-16 rounded-2xl border border-black/10 bg-white p-6 sm:p-8">
          <h2 className="font-heading text-2xl font-bold text-rc-blue">{isAwards ? "What These Awards Represent" : "Specialized Expertise"}</h2>
          <p className="mt-4 text-rc-brown leading-relaxed">{isAwards ? awardsMeaning : specializedExpertise}</p>
        </section>
      </div>
    </section>
  </div>;
}
